import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { get } from '@elliemae/ds-utilities/utils';
import moment from 'moment';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var sorter = function sorter() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      columns = _ref.columns,
      sortingColumns = _ref.sortingColumns,
      sort = _ref.sort,
      emptyLast = _ref.emptyLast;

  return function (data) {
    if (!columns) {
      throw new Error('sort.sorter - Missing "columns" argument!');
    }

    if (!sort) {
      throw new Error('sort.sorter - Missing "sort" argument!');
    }

    if (!sortingColumns) {
      return data;
    }

    var columnIndexList = new Array(sortingColumns.length);
    var orderList = new Array(sortingColumns.length);
    var actualSortFunction = sort;

    if (emptyLast) {
      actualSortFunction = function actualSortFunction(innerData, innerColumnIndexList, innerOrderList) {
        var sortedData = sort(innerData, innerColumnIndexList, innerOrderList);
        var keys = Object.keys(sortingColumns);
        var withData = sortedData.filter(function (r) {
          return keys.some(function (key) {
            return !!r[key];
          });
        });
        var withoutData = sortedData.filter(function (r) {
          return keys.some(function (key) {
            return !r[key];
          });
        });
        return [].concat(_toConsumableArray(withData), _toConsumableArray(withoutData));
      };
    }

    Object.keys(sortingColumns).forEach(function (sortingColumnKey) {
      var realColumn = columns.find(function (column) {
        return column.property === sortingColumnKey;
      });
      if (!realColumn) return;

      var columnSorter = realColumn.sort || function resolveValue(row) {
        var property = realColumn.property,
            sortBy = realColumn.sortBy;
        var value = row[sortBy || property]; // Pick resolved value by convention

        var resolvedValue = get(row, "_".concat(property), value);

        if (realColumn.type === 'DateTime') {
          return moment(resolvedValue);
        }

        return typeof resolvedValue === 'string' ? resolvedValue.toLowerCase() : resolvedValue;
      };

      var sortingColumn = sortingColumns[sortingColumnKey];
      columnIndexList[sortingColumn.position] = columnSorter;
      orderList[sortingColumn.position] = sortingColumn.direction;
    });
    return actualSortFunction(data, columnIndexList, orderList);
  };
};
var sorterGroups = function sorterGroups() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      columns = _ref2.columns,
      sortingColumns = _ref2.sortingColumns,
      sort = _ref2.sort,
      emptyLast = _ref2.emptyLast;

  return function (data, rowsData) {
    if (!columns) {
      throw new Error('sort.sorter - Missing "columns" argument!');
    }

    if (!sort) {
      throw new Error('sort.sorter - Missing "sort" argument!');
    }

    if (!sortingColumns) {
      return data;
    }

    var columnIndexList = new Array(sortingColumns.length);
    var orderList = new Array(sortingColumns.length);
    var actualSortFunction = sort;

    if (emptyLast) {
      actualSortFunction = function actualSortFunction(innerData, innerColumnIndexList, innerOrderList) {
        var sortedData = sort(innerData, innerColumnIndexList, innerOrderList);
        var keys = Object.keys(sortingColumns);
        var withData = sortedData.filter(function (r) {
          return keys.some(function (key) {
            return !!r[key];
          });
        });
        var withoutData = sortedData.filter(function (r) {
          return keys.some(function (key) {
            return !r[key];
          });
        });
        return [].concat(_toConsumableArray(withData), _toConsumableArray(withoutData));
      };
    }

    Object.keys(sortingColumns).forEach(function (sortingColumnKey) {
      var realColumn = columns.find(function (column) {
        return column.property === sortingColumnKey;
      });
      if (!realColumn) return;

      var columnSorter = realColumn.sort || function resolveValue(row) {
        var property = realColumn.property,
            sortBy = realColumn.sortBy;
        var value = row[sortBy || property]; // Pick resolved value by convention

        var resolvedValue = get(row, "_".concat(property), value);

        if (realColumn.type === 'DateTime') {
          return moment(resolvedValue);
        }

        return typeof resolvedValue === 'string' ? resolvedValue.toLowerCase() : resolvedValue;
      };

      var sortingColumn = sortingColumns[sortingColumnKey];
      columnIndexList[sortingColumn.position] = columnSorter;
      orderList[sortingColumn.position] = sortingColumn.direction;
    });
    var groups = {};
    var preserveData = {};
    data.forEach(function (c) {
      preserveData[c.id] = _objectSpread({}, c);
    });
    rowsData.forEach(function (group) {
      groups[group.id] = {
        children: actualSortFunction(group.children.map(function (c) {
          return _objectSpread({
            parentNode: preserveData[c.id].parentNode,
            data: c
          }, c);
        }), columnIndexList, orderList) // sort internally

      };
    });
    var sorted = actualSortFunction(data.map(function (r) {
      return _objectSpread(_objectSpread({}, r.data), r);
    }), columnIndexList, orderList); // sort global

    var ssortGlobal = [];
    sorted.filter(function (s) {
      return !s.isGroup;
    }).forEach(function (sr) {
      if (groups[sr.parentNode.id]) {
        ssortGlobal = [].concat(_toConsumableArray(ssortGlobal), [preserveData[sr.parentNode.id]], _toConsumableArray(groups[sr.parentNode.id].children));
        delete groups[sr.parentNode.id];
      }
    });
    return ssortGlobal;
  };
};

export { sorter, sorterGroups };
//# sourceMappingURL=sorter.js.map
